import { apiBaseUrl, apiUrls } from 'consts'

const getEntityLogoUrl = (): string => {
  return apiBaseUrl + apiUrls.actionEntityImage
}

export default getEntityLogoUrl
